import * as React from 'react';
import { Trans } from '../Trans';

export interface GroupHeaderProps {
}

export class GroupHeader extends React.PureComponent<GroupHeaderProps> {
    public render() {
        return <div className="job-center-list-item">
            <div className="row job-center-group-header">
                <div className="col-sm-5"><Trans>Bezeichnung:</Trans></div>
                <div className="col-sm-2"><Trans>Ort:</Trans></div>
                <div className="col-sm-2"><Trans>Ref.:</Trans></div>
                <div className="col-sm-3"><Trans>Sektor:</Trans></div>
            </div>
        </div>;
    }
}
